module.exports = __webpack_public_path__ + "static/media/firebaselogo.3602dbea.png";